import axios from "axios";
import { APP_PATH } from "../api/backendPath";

/**
 * useRefreshToken - Hook to refresh access token
 *
 * Works for both Doctor (role_id: 4) and Pharmacy (role_id: 5) users
 * since both use the same refresh token endpoint and session storage keys
 */
const useRefreshToken = () => {
  const access_token = sessionStorage.getItem("usr_1a2b3c");
  const refresh_token = sessionStorage.getItem("usr_4d5e6f");

  const refresh = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + APP_PATH.refreshToken,
        { refresh_token: refresh_token },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${access_token}`,
            "User-Refresh-Token": `${refresh_token}`,
            "Content-Type": "application/json",
          },
        },
      );
      return response?.data?.data;
    } catch (error) {}
  };
  return refresh;
};

export default useRefreshToken;

// import axios from "axios";
// import { APP_PATH } from "../api/backendPath";

// const useRefreshToken = () => {
//   const refresh = async () => {
//     const access_token = sessionStorage.getItem("usr_1a2b3c");
//     const refresh_token = sessionStorage.getItem("usr_4d5e6f");

//     const response = await axios.post(
//       process.env.REACT_APP_API_URL + APP_PATH.refreshToken,
//       { refresh_token },
//       {
//         headers: {
//           Authorization: `Bearer ${access_token}`,
//           "User-Refresh-Token": refresh_token,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );

//     return response.data.data;
//   };

//   return refresh;
// };

// export default useRefreshToken;
